export default __webpack_public_path__ + "svg/powered/gobvice-icex_minis_europa_blanco.svg?de886f95";